<template>
  <div id="app">

    <header-area :settings=settings></header-area>

    <section class="bg-dark2">
      <div class="container-fluid pt-3">
        <header>
          <div class="row justify-content-center align-content-center">

            <div class="col-md-12 text-center ">

              <h2 class="subtitle_heading pt-4 pb-5" v-html="$t('front_end.bravo_resultat')" v-if="sectionCount == 1"></h2>
              <h2 class="subtitle_heading pt-4 pb-5" v-html="$t('front_end.bravo_resultats')" v-if="sectionCount > 1"></h2>

              <div v-if="sectionCount == 1">

                <div class="gauge-container">
                  <div class="gauge-a"></div>
                  <div class="gauge-b"></div>
                  <div class="gauge-c" :style="rotateGaugeStyle"></div>
                  <div class="gauge-data">
                    <h1 id="percent">{{maxScore.score | number}}%</h1>
                  </div>
                </div>

                <!-- <div class="progress">
                  <div class="progress-bar" role="progressbar" :style="single_score_progress" :aria-valuenow="$options.filters.number(maxScore.score)" aria-valuemin="0" aria-valuemax="100">{{maxScore.score | number}}%</div>
                </div> -->

                <p class="pt-4 edito" v-if="$route.name === 'Additional Information'">
                  <!-- <span v-html="congrats_message['generic']" v-if="maxScore.score>=50"></span> -->
                  <!-- <span v-if="maxScore.score<50" v-html="$t('front_end.see_full_report')">{{ $t("front_end.see_full_report") }}</span> -->
                  <span v-if="maxScore.score>=50" v-html="$options.filters.translategrader(settings.copy.additionnal_info_get_results_good, $i18n.locale)"></span>
                  <span v-if="maxScore.score<50" v-html="$options.filters.translategrader(settings.copy.additionnal_info_get_results_bad, $i18n.locale)"></span>
                </p>
              </div>

              <div v-if="sectionCount > 1">
                <radarchart :height="heightRadar" :width="widthRadar" v-if="$mq !== 'sm'"></radarchart>
                <radarchart-mobile :height="heightRadar" :width="widthRadar" v-if="$mq === 'sm'"></radarchart-mobile>

                <p class="pt-4 edito" v-if="$route.name === 'Additional Information'">
                  <span v-html="congrats_message[maxScore.name]" v-if="maxScore.score>=50"></span>
                  <span v-if="maxScore.score<50" v-html="$t('front_end.see_full_report')">{{ $t("front_end.see_full_report") }}</span>
                </p>
              </div>

              <p class="pb-2">&darr;</p>
            </div>
          </div>
        </header>
      </div>
    </section>

    <main role="main" class="container-fluid">
      <router-view></router-view>
    </main>

    <footer-area :settings=settings></footer-area>
  </div>


  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Radarchart from '../components/Radarchart.vue';
import RadarchartMobile from '../components/Radarchart-mobile.vue'

export default {
    name: 'Generic',

    components: {
      FooterArea:Footer,
      HeaderArea:Header,
      Radarchart,
      RadarchartMobile,
    },

    data () {
      return {
        "congrats_message": {
          "Activité du conducteur": "Félicitations ! Vous avez une bonne visibilité de <b>l'activité de vos conducteurs</>.<br/>Pour accéder à vos résultats détaillés, découvrir les <b>bonnes pratiques</b> de votre industrie et améliorer votre performance grâce à un <b>diagnostic personnalisé</b>, merci de remplir ce formulaire",
          "Satisfaction client": "Félicitations ! La <b>satisfaction client</b> est un atout clé pour une bonne gestion de vos opérations de terrain.<br/>Pour accéder à vos résultats détaillés, découvrir les <b>bonnes pratiques</b> de votre industrie et améliorer votre performance grâce à un <b>diagnostic personnalisé</b>, merci de remplir ce formulaire",
          "Utilisation des véhicules": " Bravo ! La <b>gestion de votre flotte de véhicules</b> est votre point fort.<br/>Pour accéder à vos résultats détaillés, découvrir les <b>bonnes pratiques</b> de votre industrie et améliorer votre performance grâce à un <b>diagnostic personnalisé</b>, merci de remplir ce formulaire",
          "Productivité": "Bravo ! Vous faites de la <b>productivité de vos équipes</b> une priorité.<br/>Pour accéder à vos résultats détaillés, découvrir les <b>bonnes pratiques</b> de votre industrie et améliorer votre performance grâce à un <b>diagnostic personnalisé</b>, merci de remplir ce formulaire",
          "Conformité": "Bravo ! Vous êtes très au point sur les questions de <b>conformité</b>.<br/>Pour accéder à vos résultats détaillés, découvrir les <b>bonnes pratiques</b> de votre industrie et améliorer votre performance grâce à un <b>diagnostic personnalisé</b>, merci de remplir ce formulaire",

          "Driver Activity": "Congratulations! You have a good overview of the activity of your drivers. <br/>To access your detailed results, discover the <b>industry best practices<br/> and improve your performance thanks to a <b>customized diagnosis<br/>, please fill this form",
          "Customer Satisfaction": "Congratulations! You have a good overview on how to manage customers expectations. <br/>To access your detailed results, discover the <b>industry best practices<br/> and improve your performance thanks to a <b>customized diagnosis<br/>, please fill this form",
          "Asset Utilisation": "Congratulations! You have a good overview of the activity of your fleet. <br/>To access your detailed results, discover the <b>industry best practices<br/> and improve your performance thanks to a <b>customized diagnosis<br/>, please fill this form",
          "Productivity": "Congratulations! You have a good overview of the productivity of your team. <br/>To access your detailed results, discover the <b>industry best practices<br/> and improve your performance thanks to a <b>customized diagnosis<br/>, please fill this form",
          "Compliance": "Congratulations! You are really good when it comes to compliance. <br/>To access your detailed results, discover the <b>industry best practices<br/> and improve your performance thanks to a <b>customized diagnosis<br/>, please fill this form",

          "generic" : "Félicitations ! Vous avez une bonne visibilité de <b>la dématérialisation de vos titres restaurants</b>.<br/>Pour accéder à vos résultats détaillés, découvrir les <b>bonnes pratiques</b> de votre industrie et améliorer votre performance grâce à un <b>diagnostic personnalisé</b>, merci de remplir ce formulaire"
        },
        "maxScore": {"score": 0, "name": ""}
      }
    },

    filters: {
      number(floatNumber){
        return Math.round(floatNumber);
      }
    },


    async created() {
      this.getOrCreateSetting();

      // get the quiz using the id passed in url params
      if (this.$route.params.id !== undefined){
        var payload = {docID: this.$route.params.id};
      }
      else {
        var payload = {docID: this.surveyID};
      }
      await this.getSurveyFromID(payload);


      for (let category of this.surveyCategories) {
        var percent = 100 * parseInt(category.userScore) / parseInt(category.maxScore);
        var catName = this.$options.filters.translategrader(category.name, this.$i18n.locale)
        if (percent > this.maxScore.score){
          this.maxScore.score = percent;
          this.maxScore.name = catName
        }
      }
      // console.log(this.surveyCategories)
    },

    methods: {
      ...mapActions({
        getOrCreateSetting: 'settings/getOrCreateSetting',
        getSurveyFromID: 'survey/getSurveyFromID',
      })
    },

    computed: {

      ...mapGetters({
        settings: 'settings/settings',
        // profile: 'lead/profile',
        survey: 'survey/survey',
        surveyID: 'survey/docID',
        surveyCategories: 'survey/categories'
      }),


      sectionCount(){
        return this.surveyCategories.length;
      },

      widthRadar() {
        return this.$mq === 'sm'
        ? 300
        : 500
      },

      heightRadar() {
        return this.$mq === 'sm'
        ? 290
        : 480
      },

      single_score_progress() {
        var progress_width = "width: " + Math.floor(this.maxScore.score) + "%;";
        var color = (this.maxScore.score>50) ? 'green' : 'red';
        var background_color = "background-color: " + color + ";";
        return progress_width + background_color;
      },

      rotateGaugeStyle() {
        var angle = 180 * this.maxScore.score/100;
        return "transform: rotate(" + angle + "deg);";
      }
    },

}

</script>


<style scoped>

.bg-dark2{
  background: var(--colorPrimary);
}

header p {
  color: #fff;
}

.progress {
  height: 40px;
  max-width: 400px;
  margin: 0 auto;
}

.main_title{
  color: #fff!important;
  font-size: 16px;
  padding-top: 27px;
  display: inline-block;

}
.intro .main_title {
  padding-top: 36px;
}

.social_share_link img{
  margin-top: -8px;
}

.subtitle_heading {
  color: var(--colorSecondary);
  font-family: 'Nunito', sans-serif;
  font-size: 40px;
  margin-bottom: 0px;
  line-height: 1.3em;
}


@media only screen and (max-width: 480px) {
  .subtitle_heading {
    font-size: 35px;
  }
}

.main_title.sm, .main_title.md {
  display: none;
}

.edito {
  max-width: 650px;
  margin: 0 auto;
  font-family: 'Nunito', sans-serif;
  font-weight: 100;
  color: #dedede;
}





.gauge-container {
  width: 400px;
  height: 200px;
  position: relative;
  text-align: center;
  margin: auto;
  overflow: hidden;
}

.gauge-a {
  z-index: 1;
  position: absolute;
  background-color: rgba(255,255,255,.2);
  width: 400px;
  height: 200px;
  top: 0%;
  border-radius: 250px 250px 0px 0px;
}

.gauge-b {
  z-index: 3;
  position: absolute;
  background-color: var(--colorPrimary);
  width: 250px;
  height: 125px;
  top: 75px;
  margin-left: 75px;
  margin-right: auto;
  border-radius: 250px 250px 0px 0px;
}

.gauge-c {
  z-index: 2;
  position: absolute;
  background-color: var(--colorSecondary);
  width: 400px;
  height: 200px;
  top: 200px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0px 0px 200px 200px;
  transform-origin: center top;
  transition: all 2.3s ease-in-out;
}

.gauge-container:hover .gauge-data { color: rgba(255,255,255,1); }

.gauge-data {
  z-index: 4;
  color: rgba(255,255,255,.7);
  font-size: 1.5em;
  line-height: 25px;
  position: absolute;
  width: 400px;
  height: 200px;
  top: 120px;
  margin-left: auto;
  margin-right: auto;
  transition: all 1s ease-out;
}

</style>

<style>
@media only screen and (max-width: 768px) {
  footer {
    font-size: 12px;
  }
}

.edito strong, .edito b {
  font-weight: 900;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Generic.vue